import { enc, AES, mode, pad, lib } from 'crypto-js'

const KEY = enc.Utf8.parse('bMdYMaYeMf8XkBm1')
const IV = enc.Utf8.parse('BE7LiZPlKR62VDdz')
// 配置
const options = {
  iv: IV,
  mode: mode.CBC,
  padding: pad.Pkcs7
}
// 生成 128 位（16 字节）的随机密钥
function generateKey() {
  const randomBytes = lib.WordArray.random(16);
  return randomBytes.toString(enc.Hex);
}

// 生成 128 位（16 字节）的随机 IV
function generateIV() {
  const randomBytes = lib.WordArray.random(16);
  return randomBytes.toString(enc.Hex);
}

// 生成新的密钥和 IV
const newKeyHex = generateKey();
const newIVHex = generateIV();

// const KEY = enc.Hex.parse(newKeyHex);
// const IV = enc.Hex.parse(newIVHex);

/**
 * 加密
 * @param text 加密文本
 */
export function aesEncrypt(text) {
  // console.log("生成一个128位的密钥111", newKeyHex, enc.Hex.parse(newKeyHex));
  // console.log("生成一个128位的密钥222", newIVHex, enc.Hex.parse(newIVHex));
  const str = enc.Utf8.parse(text)
  const encrypted = AES.encrypt(str, KEY, options)
  return encrypted.ciphertext.toString().toUpperCase()
}

/**
 * 解密
 * @param text 解密文本
 */
export function aesDecrypt(text) {
  const encryptedHexStr = enc.Hex.parse(text)
  const str = enc.Base64.stringify(encryptedHexStr)
  const decrypt = AES.decrypt(str, KEY, options)
  return decrypt.toString(enc.Utf8).toString()
}
